import {Card} from "../../generic/card";
import {AsRoute} from "../../../app";
import {Order, Row, Table} from "../../generic/table";
import {WithAPI} from "../../../api/temperature";
import {useFetchAndRender} from "../../fetchAndRender";
import {DateTime} from "../../generic/date";
import {mdiDotsVertical, mdiMerge, mdiPencil, mdiScissorsCutting, mdiTimelineClockOutline} from "@mdi/js";
import {useState} from "preact/hooks";
import {Button, ButtonList, IconButton} from "../../generic/button";
import {Sensor, SensorOrder} from "../../../api/sensor";
import {Dropdown} from "../../generic/dropdown";
import Icon from "@mdi/react";
import "react-datepicker/dist/react-datepicker.css";
import {TrimSensorDialog} from "./components/trimSensorDialog";
import {CapSensorDialog} from "./components/capSensorDialog";
import {MergeSensorDialog} from "./components/mergeSensorDialog";
import {PopupMenu} from "../../generic/menu";
import {ModifySensor} from "./components/sensorDialog";

export function SensorsAdmin(props: WithAPI & AsRoute) {
    const [order, setOrder] = useState<Order<SensorOrder["attribute"]>>({
        column: "name",
        direction: "ASC"
    });

    const [result, reloadSensors] = useFetchAndRender((order) => {
        return props.api.sensor.get({
            filter: { active: undefined },
            attributes: ["id", "url", "name", "device", "last", "active"],
            order: order ? [{attribute: order.column, direction: order.direction}] : undefined
        });
    }, {interval: 0}, [order]);

    const [modifySensor, setModifySensor] = useState<Sensor | null>(null);
    const [trimByTime, setTrimByTime] = useState<Sensor | null>(null);
    const [trimByValue, setTrimByValue] = useState<Sensor | null>(null);
    const [mergeByValue, setMergeByValue] = useState<Sensor | null>(null);

    return <Card title={"Sensors"}>
        <Table<SensorOrder["attribute"] | "actions">
            columns={[
                {id: "id", title: "ID", class: "td-shrink", order: true},
                {id: "name", title: "Sensor", order: true},
                {id: "device", title: "Device ID", order: true},
                {id: "last.date", title: "Last activity", class: "td-shrink", order: true},
                {id: "actions", class: "td-shrink"},
            ]}
            onOrdered={(order: Order<SensorOrder["attribute"] | "actions">) => {
                if (order.column !== "actions") {
                    setOrder(order as Order<SensorOrder["attribute"]>);
                }
            }}
            order={order}
        >
            {(result?.sensors ?? []).map(sensor => <Row key={sensor.id} cells={{
                "id": <td class="td-shrink text-right">{sensor.id}</td>,
                "name": <th>{sensor.name}</th>,
                "device": <td><code>{sensor.device}</code></td>,
                "last.date": <td class={"td-shrink text-right" + (sensor.active ? "" : " text-danger")}>{sensor.last ? <DateTime value={sensor.last?.date} /> : <strong>Never</strong>}</td>,
                "actions": <td class="td-shrink"><ButtonList>
                    <IconButton className="btn" onClick={() => {
                        setModifySensor(sensor);
                    }} path={mdiPencil} />
                    <Dropdown
                        content={<PopupMenu>
                            <li>
                                <Button className="btn" onClick={() => {
                                    setMergeByValue(sensor);
                                }}>
                                    <Icon path={mdiMerge} size="1em" />
                                    Merge
                                </Button>
                            </li>
                            <li>
                                <Button
                                    className="btn"
                                    onClick={() => {
                                        setTrimByTime(sensor);
                                    }}
                                >
                                    <Icon path={mdiTimelineClockOutline} size="1em" />
                                    Trim by time
                                </Button>
                            </li>
                            <li>
                                <Button
                                    className="btn"
                                    onClick={() => {
                                        setTrimByValue(sensor);
                                    }}
                                >
                                    <Icon path={mdiScissorsCutting} size="1em" />
                                    Cap by value
                                </Button>
                            </li>
                        </PopupMenu>}
                        showChevron={false}
                    >
                        <Icon path={mdiDotsVertical} size="1em" />
                    </Dropdown>
                </ButtonList></td>
            }} />)}
        </Table>

        {modifySensor && <ModifySensor api={props.api} open={true} sensor={modifySensor} onOpenChange={(show) => {
            if (!show) {
                setModifySensor(null);
                reloadSensors(true);
            }
        }}/>}

        {trimByTime && <TrimSensorDialog api={props.api} open={true} sensor={trimByTime} onOpenChange={(show) => {
            if (!show) {
                setTrimByTime(null);
                reloadSensors(true);
            }
        }}/>}

        {trimByValue && <CapSensorDialog api={props.api} open={true} sensor={trimByValue} onOpenChange={(show) => {
            if (!show) {
                setTrimByValue(null);
                reloadSensors(true);
            }
        }}/>}

        {mergeByValue && <MergeSensorDialog api={props.api} open={true} sensor={mergeByValue} onOpenChange={(show) => {
            if (!show) {
                setMergeByValue(null);
                reloadSensors(true);
            }
        }}/>}
    </Card>;
}
